import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BasicRegister } from 'src/app/models/basic-register.model';
import { MgService } from 'src/app/services/mg.service';
import { ChooseBusinessDialogComponent } from '../choose-business-dialog/choose-business-dialog.component';

@Component({
  selector: 'app-call-business',
  templateUrl: './call-business.component.html',
  styleUrls: [
    './call-business.component.scss',
    './../../../../assets/scss/call-screen.scss'
  ]
})
export class CallBusinessComponent implements OnInit {
  @Input() business: BasicRegister;
  @Output() businessChanged: EventEmitter<BasicRegister> = new EventEmitter<BasicRegister>();

  constructor(
    private mg: MgService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  get phoneMask(): string {
    return this.mg.phoneMask;
  }

  public nineExtra(cell: string): string {
    return this.mg.nineExtra(cell);
  }

  public chooseBusiness(){
    const reference = this.dialog.open(ChooseBusinessDialogComponent, {
      width: '600px'
    });

    reference.afterClosed().subscribe(
      res => {
        this.businessChanged.emit(res);
      }
    )
  }

}
